import { StyledTime } from '@/components/styles';
import Icon from '@/assets/icons';
import { useEffect, useState } from 'react';

const Share = () => {
  const [shareLinks, setShareLinks] = useState(null);

  useEffect(() => {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent('Check out this page!');
    setShareLinks({
      telegram: `https://t.me/share/url?url=${url}&text=${text}`,
      viber: `viber://forward?text=${text}%20${url}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    });
  }, []);

  return (
    <StyledTime>
      {!!shareLinks && (
        <>
          <StyledTime.Desc>Share:</StyledTime.Desc>
          <StyledTime.Link href={shareLinks.telegram} target="_blank" rel="noopener noreferrer">
            <Icon width="30" height="30" name="telegram" />
          </StyledTime.Link>
          <StyledTime.Link href={shareLinks.viber} target="_blank" rel="noopener noreferrer">
            <Icon width="30" height="30" name="viber" />
          </StyledTime.Link>
          <StyledTime.Link href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer">
            <Icon width="30" height="30" name="whatsapp" fill="rgb(37, 211, 102)" />
          </StyledTime.Link>
          <StyledTime.Link href={shareLinks.facebook} target="_blank" rel="noopener noreferrer">
            <Icon width="30" height="30" name="fb" fill="#1877F2" />
          </StyledTime.Link>
        </>
      )}
    </StyledTime>
  );
};

export default Share;
